<template>
  <o-view>
    <o-nav-bar
      title="KBC"
    />
    <o-reseller-badge/>
    <div class="c-kbclist">
      <router-link to="consentkbc" class="c-kbclist__item">Mobility Assistent</router-link>
      <router-link to="sales/bike" class="c-kbclist__item">Fiets</router-link>
      <router-link to="sales/train" class="c-kbclist__item">NMBS</router-link>
      <router-link to="sales/ov/delijn" class="c-kbclist__item">De Lijn</router-link>
    </div>
  </o-view>
</template>

<script>
export default {
  name: 'KBC'
}
</script>

<style lang="scss">
.c-kbclist {
  height: 100%;
  padding: 2.4rem;
}

.c-kbclist__item {
  background-color: #FFF;
  border-radius: $border-radius-small;
  box-shadow: $box-shadow;
  color: inherit;
  display: block;
  padding: 1.6rem;

  & + & {
    margin-top: 1.6rem;
  }
}
</style>
